import React from 'react';
import './style/AboutSam.css';

const AboutSam: React.FC = () => {
  return (
    <div className="about-container">
      <div className="about-content">
        <h1>About Sam</h1>
        <div className="about-section">
          {/* Content will be added later */}
        </div>
      </div>
    </div>
  );
};

export default AboutSam;
